import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import AttributeLink from '../components/AttributeLink/AttributeLink';
import AttributeForm from '../components/AttributeForm/AttributeForm';
import AttributeHeader from '../components/AttributeHeader/AttributeHeader';
import getValueFromWindow from '../../../helpers/getValueFromWindow';
import createAttributeSelectorObject from '../helpers/createAttributeSelectorObject';
import AttributeCookies from '../helpers/AttributeCookies';
import InfoModal from '../../InfoModal/InfoModal';
import { getParameters, removeParameters } from '../../../helpers/urlHelpers';


class AttributeSelector extends Component {
  constructor(props) {
    super(props);
    const {
      formValues,
      optionTitle,
      displaySelector,
      filteringAttributes,
      allowSelection,
    } = createAttributeSelectorObject(getValueFromWindow('attribute_selector', 'filteringAttributes'));
    const queryParams = getParameters(location.href);
    const modalIsOpen = (queryParams.showSelector && queryParams.showSelector[0] === 'true') || false;


    this.optionTitle = optionTitle;
    this.displaySelector = displaySelector;
    this.allowSelection = allowSelection;
    this.filteringAttributes = filteringAttributes;
    this.state = {
      formValues,
      modalIsOpen,
    };
    this.attributeCookies = new AttributeCookies();
    this.sessionCookies = new Cookies();

    this.selectAttribute = this.selectAttribute.bind(this);
    this.submitAttribute = this.submitAttribute.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const { modalIsOpen } = this.state;
    const showSelector = this.sessionCookies.get('showSelector') === undefined;

    this.sessionCookies.set('showSelector', 'true', {
      path: '/',
      secure: process.env.TEST_ENV !== 'test',
      httpOnly: false,
      sameSite: 'none',
    });

    if (!modalIsOpen && showSelector) {
      this.setState({ modalIsOpen: true });
    }
  }

  closeModal() {
    if (location.search) {
      const filteredUrl = removeParameters(location.href, ['showSelector']);

      location.assign(filteredUrl);
    } else {
      location.reload();
    }
  }

  selectAttribute({ target: { id, value } }) {
    const { formValues } = this.state;

    formValues[id].value = value;
    this.setState({ formValues: { ...formValues } });
  }

  submitAttribute() {
    const { updateAction } = this.props;
    const { formValues } = this.state;
    const sortedKeys = Object.keys(formValues).sort((first, second) => first.order - second.order);
    const selectedAttributeValues = sortedKeys.map((key) => {
      const { value } = formValues[key];

      return `${key}=${value}`;
    });
    const currentAttributeCookieValue = this.attributeCookies.getValue();
    const newAttributeCookieValue = selectedAttributeValues.join('&');

    this.attributeCookies.setValue(newAttributeCookieValue);

    if (updateAction && currentAttributeCookieValue !== newAttributeCookieValue) {
      updateAction().then(() => {
        this.closeModal();
      });
    } else {
      this.closeModal();
    }
  }

  render() {
    const { formValues, modalIsOpen } = this.state;

    if (!this.displaySelector) {
      return null;
    }

    return (
      <div className="attribute-selector__container">
        <InfoModal
          styleFlag="attribute-selector"
          isOpen={modalIsOpen}
          message={(
            <>
              <AttributeHeader />
              <AttributeForm
                formValues={formValues}
                submitAttribute={this.submitAttribute}
                selectAttribute={this.selectAttribute}
                filteringAttributes={this.filteringAttributes}
              />
            </>
          )}
          hideIcon
          disabled={!this.allowSelection}
        >
          <AttributeLink
            locationDisplay={this.optionTitle}
            allowSelection={this.allowSelection}
          />
        </InfoModal>
      </div>
    );
  }
}

AttributeSelector.propTypes = {
  updateAction: PropTypes.func,
};

AttributeSelector.defaultProps = {
  updateAction: null,
};

export default AttributeSelector;
